import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useTiresSection } from '../../hooks/useTiresSection';

export const Tires = () => {
  const { section, orderedImages } = useTiresSection();
  const tireImages = orderedImages.filter((img): img is NonNullable<typeof img> => !!img?.url);

  return (
    <Level2Wrapper flex="1 1 100%" label="Tires">
      <ImageList label="Tires Pictures" images={tireImages} />
      {Object.entries(section?.subsections ?? {}).map(([key, sub]) => {
        const numericGrade = key.endsWith('_tire')
          ? orderedImages.find(img => img?.type === `tires.${key}`)?.grade
          : undefined;
        return <GenericSubSection key={sub.id} section={sub} additionalData={{ numericGrade }} />;
      })}
    </Level2Wrapper>
  );
};
